import {IMPERSONATION_QUERY_KEY, IMPERSONATION_TOKEN_KEY} from '@shared/constants/auth'

export const setupImpersonationHrefObserver = () => {
  const ORIGIN = window.location.origin

  const updateLink = link => {
    const token = sessionStorage.getItem(IMPERSONATION_TOKEN_KEY)

    if (!token || !link?.href) {
      return
    }

    try {
      const url = new URL(link.href, ORIGIN)

      if (url.origin !== ORIGIN) {
        return
      }

      if (url.protocol !== 'http:' && url.protocol !== 'https:') {
        return
      }

      if (link.hasAttribute('download')) {
        return
      }

      if (url.searchParams.get(IMPERSONATION_QUERY_KEY) === token) {
        return
      }

      url.searchParams.set(IMPERSONATION_QUERY_KEY, token)
      link.setAttribute('href', url.toString())
    } catch (_) {}
  }

  const handleEvent = e => {
    const link = e.target.closest('a[href]')

    if (link) {
      updateLink(link)
    }
  }

  document.addEventListener('contextmenu', handleEvent, true)
  document.addEventListener('mousedown', handleEvent, true)
  document.addEventListener('click', handleEvent, true)
}
